import type { ParamMap } from '@angular/router';
import { DEFAULT_DEVICE_HEALTH_STATE, type DeviceHealthState } from '@era/stores';

export { DEFAULT_DEVICE_HEALTH_STATE, type DeviceHealthState };

export interface DeviceHealthStateOption {
  type: DeviceHealthState;
  title: string;
}

export const DEVICE_HEALTH_STATE_OPTIONS: readonly DeviceHealthStateOption[] = [
  { type: 'all', title: 'All device states' },
  { type: 'online', title: 'Healthy/online devices' },
  { type: 'offline', title: 'Offline devices' },
  { type: 'sync-issues', title: 'Sync issues' },
];

export function isDeviceHealthState(value: string): value is DeviceHealthState {
  return DEVICE_HEALTH_STATE_OPTIONS.some((option) => option.type === value);
}

export function selectedDeviceHealthStateFromQuery(queryParamMap: ParamMap): DeviceHealthState {
  const selected = queryParamMap.get('healthState');

  return selected && isDeviceHealthState(selected) ? selected : DEFAULT_DEVICE_HEALTH_STATE;
}
